import {companyFeaturesConstants, icpTierConstants} from '../../constants';
import {useCompanyFeature} from './useCompanyFeature';

/**
 * Checks if the company's ICP tier is `small`.
 *
 * @returns {boolean} True when the `icp_tier` company feature equals `small`.
 *
 * @example
 * const isIcpTierSmall = useIsIcpTierSmall();
 */
export const useIsIcpTierSmall = () => {
  return useCompanyFeature(companyFeaturesConstants.ICP_TIER) === icpTierConstants.SMALL;
};
